import { render } from "./patient.vue?vue&type=template&id=091b2836&scoped=true"
import script from "./patient.vue?vue&type=script&lang=js"
export * from "./patient.vue?vue&type=script&lang=js"

import "./patient.vue?vue&type=style&index=0&id=091b2836&scoped=true&lang=css"

import exportComponent from "D:\\Septris Remake\\septris-remake\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091b2836"]])

export default __exports__